import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getArticle, type ArticleRow } from "../lib/api";
import { sanitizeArticleHtml } from "../lib/safeHtml";

export default function ArticleDetailPage() {
  const { articleId } = useParams<{ articleId: string }>();
  const [article, setArticle] = useState<ArticleRow | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!articleId) return;
    getArticle(articleId)
      .then((res) => setArticle(res.article))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load article."));
  }, [articleId]);

  if (error) return <p className="err">{error}</p>;
  if (!article) return <p className="muted">Loading…</p>;

  return (
    <div>
      <p>
        <Link to="/news">&larr; All news</Link>
      </p>
      <h1>{article.title}</h1>
      <p className="muted">
        {new Date(article.publishDate || article.createdAt).toLocaleDateString(undefined, {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
      </p>
      {/* Written in RichTextEditor by an admin or a club manager. Club
          managers aren't site admins, so it's sanitized (lib/safeHtml). */}
      <div className="card article-body" dangerouslySetInnerHTML={{ __html: sanitizeArticleHtml(article.body) }} />
    </div>
  );
}
